import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import FileContent from './FileContent';
import FileSideBar from './FileSidebar';
import { Card, Col, Container, Row } from 'reactstrap';
import i18n from '../../../i18n';

const FileManagerContain = () => {
    return (
        <Fragment>
            <Breadcrumbs parent={i18n.t('Dashboard_Common_App')} title={i18n.t('Dashboard_Breadcrumb_FileManager')} mainTitle={i18n.t('Dashboard_Breadcrumb_FileManager')} />
            <Container fluid={true}>
                <Row>
                    <FileSideBar />
                    <Col xl="9" md="12" className="xl-70">
                        <div className="file-content">
                            <Card>
                                <FileContent />
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};
export default FileManagerContain;
